import React, { FC } from "react";
import { Control, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { CompanyType } from "@green0meter/api-client";

import { CreateUpdateEntityFormValues } from "../../EntityEditor";
import { entityTypesFields } from "../../EntityEditor.constants";

import { FormControl, InputLabel, MenuItem, Select } from "@components/base";

interface EntityName {
  control: Control<CreateUpdateEntityFormValues>;
}

const EntityName: FC<EntityName> = ({ control }) => {
  const { t } = useTranslation();

  return (
    <Controller
      control={control}
      name="companyType"
      render={({ field }): React.ReactElement => (
        <FormControl fullWidth>
          <InputLabel>{t("entitiesManagement.entityEditor.companyType")}</InputLabel>
          <Select
            {...field}
            fullWidth
            label={t("entitiesManagement.entityEditor.companyType")}
          >
            {Object.keys(entityTypesFields)
              .filter((key) => Number(key) !== CompanyType.Supplier)
              .map((key) => (
                <MenuItem key={key} value={key}>
                  {t(`companyType.${key}`)}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      )}
    />
  );
};

export default EntityName;
